// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"264":"61da5a27","398":"be8c81f7","685":"f1a8d032","751":"3a32fbe4","867":"b8c53be3","960":"b2eaf09e"}[chunkId] + ".chunk.css";
};